<template>
  <v-card title="休假类型维护">
    <div class="grid-demo">
      <v-form slot="form">
        <!-- <v-row :gutter="24">
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="休假类型代码">
                <v-input placeholder="休假类型代码" v-model="options.xjlx_dm"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="休假类型名称">
                <v-input placeholder="休假类型名称" v-model="options.xjlx_mc"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="备注">
                <v-input placeholder="备注" v-model="options.bz"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="状态">
                <v-switch v-model="checked"></v-switch>
              </v-form-item>
            </div>
          </v-col>
        </v-row> -->
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm title="确定删除吗?" @confirm="del(row)" @cancel="cancel" placement="bottom">
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red;">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center"
          },
          {
            field: "xjlx_dm",
            title: "休假类型代码",
            align: "center"
          },
          {
            field: "xjlx_mc",
            title: "休假类型名称",
            align: "center"
          },
          {
            field: "zs",
            title: "总天数",
            align: "center"
          },
          {
            field: "xjlx_ms",
            title: "备注",
            align: "center"
          },
          {
            field: "xy_bz",
            title: "状态",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let xy_bz = row.xy_bz==1?"启用":"禁用"
                return [                  
                    <span>{xy_bz}</span>
                ];
              }
            }
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios
        .get(
          "api/system/xjlx/get-xjlx-list"
        )
        .then(res => {
          this.tableData = res.data;
        });
    },
    add: function (row) {
      let xjlx_dm = row == "" ? "" : row.xjlx_dm;
      let title = row == "" ? "添加休假类型" : "修改休假类型";
      xadmin.open(title, "/xjlxwhadd?xjlx_dm=" + xjlx_dm, "600", "500");
    },
    del: function (row) {
      this.$axios
        .get("api/system/xjlx/del-xjlx-list?xjlx_dm=" + row.xjlx_dm)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/xjlxwh.vue